module.exports = __webpack_public_path__ + "static/media/Publications-screenshot.c3c54147.png";